var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var cbor = require('ipld-dag-cbor').util;

var CID = require('cids');

var links = function links(obj) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (Buffer.isBuffer(obj)) {
    obj = cbor.deserialize(obj);
  }

  return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _i, _Object$keys, key, _path, val, i, __path, o;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _i = 0, _Object$keys = Object.keys(obj);

          case 1:
            if (!(_i < _Object$keys.length)) {
              _context.next = 34;
              break;
            }

            key = _Object$keys[_i];
            _path = path.slice();

            _path.push(key);

            val = obj[key];

            if (!(val && typeof val === 'object')) {
              _context.next = 31;
              break;
            }

            if (!Array.isArray(val)) {
              _context.next = 25;
              break;
            }

            i = 0;

          case 9:
            if (!(i < val.length)) {
              _context.next = 23;
              break;
            }

            __path = _path.slice();

            __path.push(i);

            o = val[i];

            if (!CID.isCID(o)) {
              _context.next = 18;
              break;
            }

            _context.next = 16;
            return [__path.join('/'), o];

          case 16:
            _context.next = 20;
            break;

          case 18:
            if (!(typeof o === 'object')) {
              _context.next = 20;
              break;
            }

            return _context.delegateYield(links(o, _path), "t0", 20);

          case 20:
            i++;
            _context.next = 9;
            break;

          case 23:
            _context.next = 31;
            break;

          case 25:
            if (!CID.isCID(val)) {
              _context.next = 30;
              break;
            }

            _context.next = 28;
            return [_path.join('/'), val];

          case 28:
            _context.next = 31;
            break;

          case 30:
            return _context.delegateYield(links(val, _path), "t1", 31);

          case 31:
            _i++;
            _context.next = 1;
            break;

          case 34:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })();
};

module.exports = links;